import { Injectable } from '@angular/core';
import { isBefore, isSameDay } from 'date-fns';
import { ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { map, Observable } from 'rxjs';
import { ActivityInternalTodoTableComponent } from '../../components/activity-internal-todo/activity-internal-todo-table/activity-internal-todo-table.component';
import { ActivityInternalListConfigService } from '../activity-internal-list-config/activity-internal-list-config.service';
import { ActivityInternal } from '../activity-internal/activity-internal.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityInternalTodoListConfigService extends ActivityInternalListConfigService {
  getItems(): Observable<ActivityInternal[]> {
    return this.activityInternalService.getAll().pipe(
      map(result => {
        return result.filter(r => {
          const todayDate = new Date();
          const activityDate = new Date(r.activityDate);

          if (isSameDay(activityDate, todayDate) || isBefore(activityDate, todayDate)) {
            return true;
          }
        });
      }),
      map(result =>
        result.sort((a, b) => {
          if (new Date(a.activityDate) > new Date(b.activityDate)) {
            return 1;
          }
          if (new Date(a.activityDate) < new Date(b.activityDate)) {
            return -1;
          }
          return 0;
        })
      )
    );
  }

  getLayouts(): ListLayout<ActivityInternal>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => ActivityInternalTodoTableComponent as any,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Order list'
      }
    ];
  }
}
